<template>
    <div v-if="!invalidateData" class="fulfillment-export-field">
        <DsIcon
            name="draggable"
            class="field-icon"
        />
        <DsMultiselect
            :value="valueArray[identifier]"
            bind-value-only
            class="field-name"
            categorized
            searchable
            :options="categoryOptions"
            :label="$t('funnel.edit.fulfillment.list.select')"
            @input="setFieldValueAndLabel"
        />
        <span class="field-separator">=</span>
        <DsInputField
            :value="labelArray[identifier]"
            class="field-label"
            @input="setLabel"
        />
        <DsIconButton
            name="minus-circle"
            class="field-delete"
            @click="deleteField"
        />
        <div class="line-separator" />
    </div>
</template>

<script>
export default {
    props: {
        identifier: {
            type: Number,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        valueArray: {
            type: Array,
            required: true,
        },
        labelArray: {
            type: Array,
            required: true,
        },
        categoryOptions: {
            type: Array,
            required: true,
        },
    },
    emits: ['delete-field', 'configure-field', 'configure-label'],

    data() {
        return {
            invalidateData: false,
        };
    },

    methods: {
        deleteField() {
            this.$emit('delete-field');
        },

        setFieldValueAndLabel(value) {
            this.invalidateData = true;
            this.$emit('configure-field', value);

            this.$nextTick().then(() => {
                this.invalidateData = false;
            });
        },

        setLabel(label) {
            this.$emit('configure-label', label);
        },
    },
};
</script>
<style lang="scss" scoped>
.fulfillment-export-field {
    display: grid;
    grid-template-areas: 'fieldicon fieldname fieldseparator fieldlabel fielddelete';
    grid-template-columns: $spacing-600 auto $spacing-600 auto $spacing-600;
    align-items: center;
    justify-items: center;
    padding-bottom: $spacing-300;
}
.field-icon {
    grid-area: fieldicon;
}
.field-name {
    grid-area: fieldname;
    margin-bottom: 0;
}
.field-label {
    grid-area: fieldlabel;
    margin-bottom: 0;
}
.field-separator {
    grid-area: fieldseparator;
}
.field-delete {
    grid-area: fielddelete;
}
</style>
